import { ReactNode } from "react";

import { Content } from "./content";

export const ExistingUser = (props: {
    EmailInput?: ReactNode;
    SignInLink?: ReactNode;
    SiteNameInput?: ReactNode;
    NewSiteLink?: ReactNode;
    SitePicker?: ReactNode;
    PrivacyPolicy?: ReactNode;
    SubmitButton?: ReactNode;
}) => <Content {...props} />;
